import { render, staticRenderFns } from "./linkReplace.vue?vue&type=template&id=a361da42&scoped=true"
import script from "./linkReplace.vue?vue&type=script&lang=js"
export * from "./linkReplace.vue?vue&type=script&lang=js"
import style0 from "./linkReplace.vue?vue&type=style&index=0&id=a361da42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a361da42",
  null
  
)

export default component.exports